import React from "react";
import { WHICHENSURE_TYPES, CLIENT_TYPES } from "./personaldata";
import housing from '../assets/images/icons/housing.svg';
import clientAssets from '../assets/images/icons/client-assest.svg';
import housingAssets from '../assets/images/icons/housing-assets.svg';
import propertyAssets from '../assets/images/landing/property-assets.png';

export const WHICH_ENSURE_CLIENT_TYPE_CARDS = {
    [CLIENT_TYPES.OWNER]: {
        icons: ["housing", "client-assest", "housing-assets"],
        images: [housing, clientAssets, housingAssets],
        img: propertyAssets,
        title: {
            housing: "Inmueble",
            "client-assest": "Bienes",
            "housing-assets": "Ambos",
        },
        description: (
            <>
                Si eres <b>propietario</b>
                <br />
                de una casa o departamento,
                <br />
                puedes asegurar:{"\n"}
            </>
        ),
    },
    [CLIENT_TYPES.ROOMER]: {
        icons: ["client-assest"],
        img: "landing/property-roomer.png",
        title: { "client-assest": "Bienes" },
        description: (
            <>
                Si eres <b>inquilino </b>de una casa
                <br />
                o departamento,
                <br />
                puedes asegurar:{"\n"}
            </>
        ),
    },
};

export const FIXED_PLAN_ANNUAL_PLANS_BY_WHICH_ENSURE = {
    [WHICHENSURE_TYPES.HOUSING]: [
        { annualAmount: 250000, monthlyAmount: 99.9 },
        { annualAmount: 100000, monthlyAmount: 71.9 },
        { annualAmount: 50000, monthlyAmount: 61.9 },
    ],
    [WHICHENSURE_TYPES.ASSETS]: [
        { annualAmount: 50000, monthlyAmount: 51.9 },
        { annualAmount: 20000, monthlyAmount: 40.9 },
        { annualAmount: 10000, monthlyAmount: 32.52 },
    ],
};

export const ALLOWED_ASSETS_PLANS_BY_HOUSING_PLAN = {
    250000: [50000, 20000, 10000],
    100000: [50000, 20000, 10000],
    50000: [10000],
};

export const FIXED_PLAN_HOUSING_ASSETS_MONTHLY_AMOUNTS_COMBINATIONS = [
    {
        housingAnnualAmount: 50000,
        assetsAnnualAmount: 10000,
        housingAssetsMonthlyAmount: 92.21,
    },
    {
        housingAnnualAmount: 100000,
        assetsAnnualAmount: 10000,
        housingAssetsMonthlyAmount: 102.2,
    },
    {
        housingAnnualAmount: 100000,
        assetsAnnualAmount: 20000,
        housingAssetsMonthlyAmount: 110.58,
    },
    {
        housingAnnualAmount: 100000,
        assetsAnnualAmount: 50000,
        housingAssetsMonthlyAmount: 121.58,
    },
    {
        housingAnnualAmount: 250000,
        assetsAnnualAmount: 10000,
        housingAssetsMonthlyAmount: 130.19,
    },
    {
        housingAnnualAmount: 250000,
        assetsAnnualAmount: 20000,
        housingAssetsMonthlyAmount: 138.58,
    },
    {
        housingAnnualAmount: 250000,
        assetsAnnualAmount: 50000,
        housingAssetsMonthlyAmount: 149.57,
    },
];
